import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAEDE6]/85 backdrop-blur-xl border-b border-[#B78782]/20"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 flex items-center justify-between h-20">
        <a href="#top" data-testid="logo-link" className="flex flex-col leading-none">
          <span className="font-serif-display text-2xl md:text-[28px] font-medium tracking-tight text-[#4A3737]">
            Amber's
          </span>
          <span className="text-[10px] md:text-[11px] tracking-[0.32em] uppercase text-[#B78782] mt-0.5">
            Mobile Beauty
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="nav-link text-[13px] tracking-[0.24em] uppercase text-[#4A3737] hover:text-[#B78782]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="header-enquire-btn"
          className="hidden md:inline-flex items-center text-[12px] tracking-[0.28em] uppercase border border-[#B78782] text-[#4A3737] px-5 py-2.5 hover:bg-[#B78782] hover:text-[#FAEDE6] transition-colors duration-300"
        >
          Enquire
        </a>

        <button
          data-testid="menu-toggle"
          aria-label="Toggle menu"
          className="md:hidden text-[#4A3737]"
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FAEDE6]/95 backdrop-blur-xl border-t border-[#B78782]/20">
          <nav className="flex flex-col px-8 py-6 gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.24em] uppercase text-[#4A3737] hover:text-[#B78782]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-enquire-btn"
              className="mt-2 inline-flex justify-center items-center text-xs tracking-[0.28em] uppercase border border-[#B78782] text-[#4A3737] px-5 py-3 hover:bg-[#B78782] hover:text-[#FAEDE6] transition-colors duration-300"
            >
              Enquire
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
